module.exports = __webpack_public_path__ + "img/fte-project.3ea45600.svg";